import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MosMessage from './MosMessage';

const Container = styled.table`
  width: 100%;
`;

class MosMessageLogTable extends PureComponent {
  render() {
    return (
      <Container>
        {this.props.logs.map(m => (
          <MosMessage key={m.timestamp} timestamp={m.timestamp} type={m.type} content={m.content} />
        ))}
      </Container>
    );
  }
}

MosMessageLogTable.defaultProps = {
  logs: []
};

MosMessageLogTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      content: PropTypes.string,
      timestamp: PropTypes.number
    })
  )
};

export default MosMessageLogTable;



// WEBPACK FOOTER //
// ./app/components/Test/ContainerTest/MosMessageLogTable.js